export const CLASS_TIPS = 'tips';
export const TIPS_ANIMATION_LENGTH = 300; // при изменении также менять в _CardAttachmentsTip.scss
export const TIPS_HIDE_TIME = 4000;
